import FeatureFeedbackPopup                      from '../FeatureFeedback/components/FeatureFeedbackPopup.js';
import React, {useCallback, useEffect, useState} from 'react';
import FeatureFeedbackPopupRatingButtonsLikes    from '../FeatureFeedback/components/FeatureFeedbackPopupRatingButtonsLikes.js';
import withFeatureFeedback                       from '../FeatureFeedback/withFeatureFeedback.js';
import Translations                              from '../../utils/Translations.js';
import Flux                                      from '../../flux/Flux.js';
import PropTypes                                 from 'prop-types';
import style                                     from './FeatureFeedback.module.less';

const preventClick = (e) => e.stopPropagation();

const FeatureFeedbackPopupWrapper = ({additionalClassNames, onSubmit, isSent}) => {
    const [feedbackRatingInfo, setFeedbackRatingInfo] = useState(null);
    const [text, setText]                             = useState('');

    // handlers
    const onOpen         = (featureId, rating) => {
        setFeedbackRatingInfo({featureId, rating});
    };
    const onChangeText   = useCallback((inputText) => {
        setText(inputText);
    }, []);
    const handleOnSubmit = useCallback(() => {
        onSubmit(feedbackRatingInfo.featureId, feedbackRatingInfo.rating, text);
    }, [feedbackRatingInfo]);
    const onSelectRating = useCallback((rating) => {
        setFeedbackRatingInfo({...feedbackRatingInfo, rating});
    });
    const onClose        = () => {
        setFeedbackRatingInfo(null);
    };

    // trigger opening
    useEffect(() => {
        Flux.Guest.addFeatureFeedbackSetListener(onOpen);

        return () => {
            Flux.Guest.removeFeatureFeedbackSetListener(onOpen);
        };
    }, []);

    // no data?
    if (!feedbackRatingInfo || isSent) {
        return null;
    }

    return (<div className={style['feature-feedback-popup-container'] + ' ' + additionalClassNames}
                 onClick={preventClick}
                 onTouchStart={preventClick}
                 key={feedbackRatingInfo.featureId}>
                <div className="feature-feedback feature-feedback--standalone">
                    <FeatureFeedbackPopup open={true}
                                          title={Translations.get('FeatureFeedbackPopupTitle')}
                                          text={text}
                                          customFeedbackRatingButtons={FeatureFeedbackPopupRatingButtonsLikes}
                                          initialSelectedRating={feedbackRatingInfo.rating}
                                          selectedRating={feedbackRatingInfo.rating}
                                          onSelectRating={onSelectRating}
                                          onSubmit={handleOnSubmit}
                                          onCancel={onClose}
                                          featureId={feedbackRatingInfo.featureId}
                                          onChangeText={onChangeText}
                    /></div>
            </div>
    );
};

FeatureFeedbackPopupWrapper.propTypes = {
    additionalClassNames: PropTypes.string,
    onSubmit:             PropTypes.func,
    isSent:               PropTypes.bool,
};

export default withFeatureFeedback(FeatureFeedbackPopupWrapper);
